export const SupportedPaymentMethods = {
  CARD: 'card',
  PAYPAL: 'pay_pal',
  BANK: 'ebanking',
  OXXO: 'oxxo',
  AFFIRM: 'affirm',
  APPLEPAY: 'apple_pay',
  GOOGLEPAY: 'google_pay',
} as const;

export const PaymentMethods = [
  'card',
  'pay_pal',
  'ebanking',
  'oxxo',
  'sepa_debit',
  'ideal',
  'affirm',
  'apple_pay',
  'google_pay',
] as const;

export const SupportedProcessors = {
  // @deprecated STRIPE: 'StripePlatformGateway',
  // @deprecated ADYEN: 'AdyenGateway',
  STRIPE: 'stripe',
  ADYEN: 'adyen',
  PAYPAL: 'paypal',
  DLOCAL: 'dlocal',
};

// TODO: infer from SupportedProcessors
export const Processors = ['stripe', 'adyen', 'paypal', 'dlocal'] as const;

export const Locale = [
  'ach_UG', 'ca_ES', 'de_DE', 'en_US', 'es_MX', 'fr_FR', 'id_ID', 'it_IT', 'pt_BR', 'th_TH',
] as const;

export const BillingRequiredValues = {
  MANDATORY: 'mandatory',
  OPTIONAL: 'optional',
};

export const GatewayModeValues = {
  LIVE: 'live',
  TEST: 'test',
};

export const CaptureMode = {
  CHARGE: 'auto',
  AUTH: 'manual',
} as const;

export const PAYMENT_METHOD_HASH_TYPE_STRIPE = 'stripe_payment_method';
export const PAYMENT_METHOD_HASH_TYPE_PAYPAL = 'paypal';
export const PAYMENT_METHOD_HASH_TYPE_TOKENEX = 'card_tokenex';

export const NEXT_ACTION_TYPE_DONE = 'done';
export const NEXT_ACTION_TYPE_REDIRECT = 'redirect';
export const NEXT_ACTION_TYPE_STRIPE_CONFIRM = 'stripe_confirmation_details';
export const NEXT_ACTION_TYPE_PAYPAL_ORDER = 'paypal_details';

export const HTTP_METHOD_GET = 'GET';
export const HTTP_METHOD_POST = 'POST';
